module.exports = __webpack_public_path__ + "static/media/trade@2x.3e08789e.png";